'use client';

import React from 'react';
import { CheckCircle } from 'lucide-react';

const FormFooter: React.FC = () => {
  return (
    <div className="mt-6 flex flex-wrap items-center justify-center gap-2 sm:flex-row sm:gap-6 text-sm text-gray-600">
      <div className="flex items-center space-x-2">
        <CheckCircle className="w-4 h-4 text-green-600" />
        <span className="font-semibold">No obligation</span>
      </div>
      <div className="flex items-center space-x-2">
        <CheckCircle className="w-4 h-4 text-green-600" />
        <span className="font-semibold">1 hour response</span>
      </div>
      <div className="flex items-center space-x-2">
        <CheckCircle className="w-4 h-4 text-green-600" />
        <span className="font-semibold">Best rates</span>
      </div>
    </div>
  );
};

export default FormFooter;